import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContextProvider } from '../../../AppLoader';
import { ThemedText } from '../../../ThemedComponents';
import { dataHooks } from '../../../../stores/premiumUsers2FaEnforcement/dataHooks';
import { CodeStepCard } from '../CodeStepCard';
import { VerificationState } from '../../VerifyButton';

/**
 * redesigned authenticator-app "enter code" step (wix-2025). A thin wrapper
 * on the shared `CodeStepCard` (same screen SMS/email use), with no resend (codes come
 * from the app) and the digit-only / 6-char input.
 */
export const AuthenticatorAppCodeStepRedesign: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { authenticatorAppModals: store },
      },
    },
  } = useContext(AppContextProvider);

  return (
    <CodeStepCard
      title={store.codeModalTitle}
      subtitle={t('multiFactorAuth.addAuthApp.codeModal.content.description')}
      onBack={store.onBackToQrModalModalSubmit}
      onVerify={() => store.onCodeModalSubmit()}
      verifyDisabled={!store.isSubmittable || !store.codeField.isDirty}
      showLoader={store.verificationState !== VerificationState.Unverified}
      field={store.codeField}
      maxLength={6}
      onlyDigits
      inputDataHook={
        dataHooks.multiFactorAuth.addAuthApp.codeModal.codeField.input
      }
      comment={
        <ThemedText size="small" secondary>
          {t('multiFactorAuth.addAuthApp.codeModal.content.comment')}
        </ThemedText>
      }
    />
  );
});
